/**
 * Open something Bailey got ready — in the diary's OWN panel.
 *
 * Bookings go to the new-booking panel; events and time off go to the
 * event/leave panel. On the diary already: one window event, and the diary
 * jumps to the day and opens the panel filled in. Anywhere else: the seed is
 * left in sessionStorage (the diary's existing rebook hand-off for bookings,
 * 'beu-bailey-item' for the rest) and we go to the diary, which opens it on
 * arrival. Either way the person saves it there; Bailey adds nothing himself.
 */
export const BAILEY_BOOK_EVENT = 'beu:bailey-book';
export const BAILEY_ITEM_EVENT = 'beu:bailey-item';
// Fired by the diary when an event or leave is saved (bookings use
// 'diary:booking-created').
export const ITEM_CREATED_EVENT = 'diary:item-created';

const onDiary = () => /^\/diary(\/|$)/.test(window.location.pathname);

function goToDiary(history) {
  const salonId = localStorage.getItem('salonId') || '';
  if (history) history.push(`/diary/${salonId}`);
  else window.location.assign(`/diary/${salonId}`);
}

export function openProposedBooking(card, history) {
  if (!card) return;
  const seed = {
    staffId: card.staffId || '',
    bookingDate: card.bookingDate,
    startMinutes: card.startMinutes,
    client: card.client || null,
    // Someone who isn't a client yet: their details, for the add-client form.
    newClient: card.newClient || null,
    services: card.services || [],
    // A repeat Bailey set up ("every 6 weeks"): the panel opens with Repeat on
    ...(card.repeat ? { repeat: card.repeat } : {}),
  };
  if (onDiary()) { window.dispatchEvent(new CustomEvent(BAILEY_BOOK_EVENT, { detail: seed })); return; }
  try { sessionStorage.setItem('beu-rebook', JSON.stringify(seed)); } catch (e) { /* ignore */ }
  goToDiary(history);
}

export function openProposedItem(card, history) {
  if (!card) return;
  const seed = {
    mode: card.mode || (card.type === 'leave' ? 'leave' : 'event'),
    staffId: card.staffId || '',
    date: card.date,
    startMinutes: card.startMinutes,
    endMinutes: card.endMinutes,
    endDate: card.endDate,
    title: card.title || '',
    leaveType: card.leaveType,
    isBookingAllowed: card.isBookingAllowed === true,
  };
  if (onDiary()) { window.dispatchEvent(new CustomEvent(BAILEY_ITEM_EVENT, { detail: seed })); return; }
  try { sessionStorage.setItem('beu-bailey-item', JSON.stringify(seed)); } catch (e) { /* ignore */ }
  goToDiary(history);
}

/** Any card Bailey returns that opens a diary panel. */
export function openProposal(card, history) {
  if (!card) return false;
  if (card.type === 'booking') { openProposedBooking(card, history); return true; }
  if (card.type === 'event' || card.type === 'leave') { openProposedItem(card, history); return true; }
  return false;
}

const hhmm = (m) => `${String(Math.floor((Number(m) || 0) / 60)).padStart(2, '0')}:${String((Number(m) || 0) % 60).padStart(2, '0')}`;
const dayOf = (iso) => {
  const d = new Date(`${iso}T00:00:00`);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
};
const first = (name) => (name ? String(name).split(' ')[0] : '');

/** "Wed 24 Sep, 14:00 with Anna" for bubbles and cards. */
export function describeBooking(card) {
  if (!card) return '';
  return `${dayOf(card.bookingDate)}, ${hhmm(card.startMinutes)}${card.staffName ? ` with ${first(card.staffName)}` : ''}`;
}

/** Any proposal, in one line. */
export function describeProposal(card) {
  if (!card) return '';
  if (card.type === 'booking') return describeBooking(card);
  const who = first(card.staffName);
  if (card.type === 'leave') {
    const range = card.endDate && card.endDate !== card.date ? `${dayOf(card.date)} – ${dayOf(card.endDate)}` : dayOf(card.date);
    return `${who ? `${who} off, ` : 'Time off, '}${range}`;
  }
  return `${card.title || 'Event'}, ${dayOf(card.date)} ${hhmm(card.startMinutes)}–${hhmm(card.endMinutes)}${who ? ` for ${who}` : ''}`;
}
